<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> COMPARATIVO DE PRODUTOS </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      ></alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="months"
                v-model="month"
                label="Mês"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="years"
                v-model="year"
                label="Ano"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="6" md="4">
              <v-select
                :items="types"
                v-model="type"
                label="Tipo de Comparação"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="6" md="2">
              <v-btn
                dark
                color="blue darken-3"
                small
                class="mt-1"
                :href="getUrlReport()"
                target="_blank"
              >
                Executar Consulta
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import { URL } from "@/api/config";
import Alert from "@/components/Alert";

export default {
  components: { Alert },
  directives: {},
  data: () => ({
    months: [
      { value: 1, text: "Janeiro" },
      { value: 2, text: "Fevereiro" },
      { value: 3, text: "Março" },
      { value: 4, text: "Abril" },
      { value: 5, text: "Maio" },
      { value: 6, text: "Junho" },
      { value: 7, text: "Julho" },
      { value: 8, text: "Agosto" },
      { value: 9, text: "Setembro" },
      { value: 10, text: "Outubro" },
      { value: 11, text: "Novembro" },
      { value: 12, text: "Dezembro" },
    ],
    month: "",
    years: [],
    year: "",
    types: [
      { value: 1, text: "Produtos de Conservação" },
      { value: 2, text: "Acessórios" },
    ],
    type: "",
    loading: false,
    messageAlert: "",
    showAlert: false,
    typeAlert: "error",
    lazy: false,
    valid: true,
  }),
  computed: {},
  created() {
    let dateNow = new Date();
    let yearNow = dateNow.getFullYear();
    // COLOCA 10 ANOS PARA TRAS
    for (let i = 10; i >= 0; i--) {
      this.years.push(yearNow - i);
    }
    this.years = this.years.reverse();
    this.initialize();
  },
  methods: {
    initialize() {},
    getUrlReport() {
      if (this.month === "") {
        return;
      }
      if (this.year === "") {
        return;
      }
      if (this.type === "") {
        return;
      }
      return `${URL}report/product-comparison/${this.month}/${this.year}/${this.type}`;
    },
  },
};
</script>
